import React, { PureComponent } from 'react'
import { Paper } from '@material-ui/core'

import EditableHOCWrapper from '../../../containers/HOC/EditableHOC'
import ComplexTaxOptionItem from './ComplexTaxOptionItem'
import { monolithIsFeatureFlagEnable } from '../../../api/unleash'
import { UnleashToggles } from '../../../types/unleashToggles'

const ComplexTaxOptionEditable = EditableHOCWrapper(ComplexTaxOptionItem)

export default class ComplexTaxOptions extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      surchargeTerritoryTaxFlag: false,
      taxOnSubtotalFlag: false,
    }
  }

  componentDidMount() {
    this.handleSurchargeExciseTax()
    this.handleTaxOnSubtotalFlag()
  }

  handleSurchargeExciseTax = () => {
    monolithIsFeatureFlagEnable(UnleashToggles.SURCHARGE_TAX_TERRITORY_TAX).then((res) => {
      this.setState({ surchargeTerritoryTaxFlag: res })
    })
  }

  handleTaxOnSubtotalFlag = () => {
    monolithIsFeatureFlagEnable(UnleashToggles.CAN_USE_TAX_ON_SUBTOTAL).then((res) => {
      this.setState({ taxOnSubtotalFlag: res })
    })
  }

  onSave = (index) => (data, func) => {
    const { taxTables } = this.props.data

    let taxTablesCopy = [...taxTables]

    taxTablesCopy[index] = data

    this.props.onSave([...taxTablesCopy], func)
  }

  render() {
    const { surchargeTerritoryTaxFlag, taxOnSubtotalFlag } = this.state
    const { taxTables = [], nalExciseAfterCityTax } = this.props.data
    const {
      lastModified,
      showEdit = true,
      isNonCannabis = false,
      state,
      allowDelivery,
      isNalTaxesOnly,
      isNalExciseAfterCityTax,
      isCDTFAEnabled = false,
      consumerTypes,
    } = this.props
    return taxTables.map((taxData, index) => {
      return (
        <Paper className="paper-page" key={index}>
          <ComplexTaxOptionEditable
            dataToEdit={taxData}
            showExcise={this.props.showExcise}
            onSave={this.onSave(index)}
            lastModified={lastModified}
            showEdit={showEdit}
            isNonCannabis={isNonCannabis}
            state={state}
            allowDelivery={allowDelivery}
            nalExciseAfterCityTax={nalExciseAfterCityTax || isNalExciseAfterCityTax}
            isNalTaxesOnly={isNalTaxesOnly}
            surchargeTerritoryTaxFlag={surchargeTerritoryTaxFlag}
            isCDTFAEnabled={isCDTFAEnabled}
            consumerTypes={consumerTypes}
            taxOnSubtotalFlag={taxOnSubtotalFlag}
          />
        </Paper>
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/ComplexTaxOptions/ComplexTaxOptions.js